import { CustomDialog, DialogInformer } from './UI/CustomDialog';
import { BaseSpriteInterface } from './SpriteInterfaces';
import ChunkedScene from './ChunkedScene';
import MainScene from 'src/app/Scenes/MainScene';
import { Preferences } from '@capacitor/preferences';

export class Character extends DialogInformer {
  name: string;
  dialogContent: string;
  url: string;
  dialog: CustomDialog;
  constructor(
    data: BaseSpriteInterface,
    anim: string = 'idle',
    name: string,
    dialogContent: string = '{}',
    url: string = '',
    playerScale: number = 1,
    characterScale: number = 1,
    frame?: string,
    token?: string
  ) {
    let { scene, x, y, texture } = data;

    // Determine if we should animate the sprite
    if (frame) {
      super(scene.matter.world, x, y, texture, frame);
    } else {
      super(scene.matter.world, x, y, texture);
      this.anims.animationManager.get(anim);
      this.anims.play(anim, true);
    }

    this.token = token;

    // Establish character name, dialog, and websites
    this.name = name;
    this.dialogContent = dialogContent;
    this.url = url;
    const bodies = new Phaser.Physics.Matter.MatterPhysics(scene).bodies;
    var characterSensor = bodies.circle(this.x, this.y, ChunkedScene.tileWidth / 2, {
      isSensor: false,
      label: 'characterSensor',
    });
    this.setExistingBody(characterSensor);
    this.setStatic(true);
    const scale = characterScale !== 1 ? characterScale : playerScale;
    this.setScale(scale);
    this.setDepth(0);
  }

  static preload(scene) {
    // Load witch data
    scene.load.atlas(
      'witch',
      'assets/sprites/witch.png',
      'assets/sprites/witch_atlas.json'
    );
    scene.load.animation('witch_anims', 'assets/sprites/witch_anim.json');

    // Load Professor Mobius data
    scene.load.atlas(
      'Professor Mobius',
      'assets/sprites/mobius.png',
      'assets/sprites/mobius_atlas.json'
    );
    scene.load.animation('Professor Mobius_anims', 'assets/sprites/mobius_anim.json');

    // Load Dr.Klein data
    scene.load.atlas(
      'Dr.Klein',
      'assets/sprites/klein.png',
      'assets/sprites/klein_atlas.json'
    );
    scene.load.animation('Dr.Klein_anims', 'assets/sprites/klein_anim.json');

    // Load Allie
    scene.load.atlas(
      'Allie',
      'assets/sprites/F_01.png',
      'assets/sprites/character_atlas.json'
    );
    scene.load.animation('F_01_anims', 'assets/sprites/F_01_anim.json');

    // // Load Julie
    scene.load.atlas(
      'Julie',
      'assets/sprites/F_04.png',
      'assets/sprites/character_atlas.json'
    );
    scene.load.animation('F_04_anims', 'assets/sprites/F_04_anim.json');

    // Load Geneva
    scene.load.atlas(
      'Geneva',
      'assets/sprites/F_07.png',
      'assets/sprites/character_atlas.json'
    );
    scene.load.animation('F_07_anims', 'assets/sprites/F_07_anim.json');

    // Load Jessie
    scene.load.atlas(
      'Jessie',
      'assets/sprites/F_10.png',
      'assets/sprites/character_atlas.json'
    );
    scene.load.animation('F_10_anims', 'assets/sprites/F_10_anim.json');

    // Load Rajan
    scene.load.atlas(
      'Rajan',
      'assets/sprites/M_01.png',
      'assets/sprites/character_atlas.json'
    );
    scene.load.animation('M_01_anims', 'assets/sprites/M_01_anim.json');

    // Load Nate
    scene.load.atlas(
      'Nate',
      'assets/sprites/M_03.png',
      'assets/sprites/character_atlas.json'
    );
    scene.load.animation('M_03_anims', 'assets/sprites/M_03_anim.json');

    // Load Philip
    scene.load.atlas(
      'Philip',
      'assets/sprites/M_07.png',
      'assets/sprites/character_atlas.json'
    );
    scene.load.animation('M_07_anims', 'assets/sprites/M_07_anim.json');
  }

  openDialog() {
    if(this.active){
      this.dialog = new CustomDialog(this, '', this.token);
    }
  }

  closeDialog() {
    if (this.dialog && this.dialog.dialog){
      this.dialog.close();

      // After the dialog has been displayed and the condition is met
      if(this.name === "Dr.Klein" && MainScene.tokens.includes("Richmond Vampire")){
        try{
          this.scene['tweenCharactersAlongPoints']();
          if(!MainScene.tokens.includes("Electric Arc Seen")){
            MainScene.tokens.push("Electric Arc Seen");
            Preferences.set({key: "tokens", value: JSON.stringify(MainScene.tokens)});
            // Store clientModifiedAt in Preferences
            Preferences.set({
              key: 'clientModifiedAt',
              value: new Date().toISOString(),
            });
          }
        }
        catch(e){
          console.log("No animateElectricArc function found in scene.");
        }
      }
      // if (dialogObj.event && dialogObj.condition) {
      //   // Check your game state for the condition, e.g.:
      //   if (this.scene.someGameStateFlag === dialogObj.condition) {
      //     if (typeof this.scene[dialogObj.event] === 'function') {
      //       this.scene[dialogObj.event]();
      //     }
      //   }
      // }
    }
  }
}
